import { render, staticRenderFns } from "./IForm.vue?vue&type=template&id=19e4474c&scoped=true&"
import script from "./IForm.vue?vue&type=script&lang=ts&"
export * from "./IForm.vue?vue&type=script&lang=ts&"
import style0 from "./IForm.vue?vue&type=style&index=0&id=19e4474c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e4474c",
  null
  
)

export default component.exports